/** Test IDs for QA automation. */
export const testIds = {
  shipmentFormOrderTypeSwitch: "shipment-form-order-type-switch",
} as const;
